import { AdvertisementPosition } from '../features/advertisement/types.ts';

export const GeneralAdAspectRatio = 400 / 100;

export const NavBarAdAspectRatio = 200 / 38;

export const useAdAspectRatio = (position: AdvertisementPosition) => {
  switch (position) {
    case AdvertisementPosition.NavbarOne:
    case AdvertisementPosition.NavbarTwo:
    case AdvertisementPosition.NavbarThree:
      return NavBarAdAspectRatio;
    case AdvertisementPosition.General:
    case AdvertisementPosition.MarketReport:
      return GeneralAdAspectRatio;
    case AdvertisementPosition.Unknown:
    default:
      return undefined;
  }
};
